import React from 'react';
import TopBar from '../../../Components/TopBar';
import Page from '../../../Components/Containers/Page';
import { useSettings } from '../../../Data/Settings';
import Form, { Actions, Settings, parseSettingsToData } from '../../../Components/Form';

const QuoteOptions = () => {
    const {settings, update} = useSettings('/quotes/settings', 'Quote options updated');
    const filter = ['Quotes:FrequencyChoices', 'Quotes:HideFields'];

    const handleSubmit = (data) => {
        const newData = {
            'Quotes:HideFields': data['Quotes:HideFields'],
            'Quotes:FrequencyChoices': data['Quotes:FrequencyChoices'].map(option => option.frequency),
        }

        return update(newData);
    }

    return <>
        <TopBar left="BackBtn" title="Quote Options" />

        <Page>
            <div className="prose my-3">
                <p>Customise the options your customers see when requesting a quote.</p>

                {/* TODO - link to quote widget */}

            </div>

            <Form data={parseSettingsToData(settings, filter)} waitForData onSubmit={handleSubmit}>
                <Settings settings={settings} filter={filter} />
                <Actions submit={{label: 'Save'}} />
            </Form>
        </Page>
    </>
}

export default QuoteOptions;
